import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function menuReducer(state= initialState.menu, action){
	switch(action.type){
		case types.SET_MENU_SUCCESS:
			return action.datos;		
	
		default:
			return state;
	}
}